import { CategoryApiResponse, SelectedCategory } from '@/types';
import QuestionAnswersTable from './QuestionAnswersTable';
import useCategoryStore from '@/store/CategoryStore';
import { useGetInterviewQuestionTransripts } from '@/reactQuery/get';
import { useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import useTranslation from '@/hooks/useTranslation';

interface TranscriptsProps {
  questionID: string | undefined;
  selectedCategories: SelectedCategory[];
  setSelectedCategories: (category: SelectedCategory[]) => void;
  categories?: CategoryApiResponse;
  isPendingInterviewQuestions: boolean;
}

export function Transcripts({
  questionID,
  selectedCategories,
  setSelectedCategories,
  categories,
  isPendingInterviewQuestions,
}: TranscriptsProps) {
  return (
    <div className="w-full py-4">
      <QuestionAnswersTable
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        questionID={questionID}
        categories={categories}
        isPendingInterviewQuestions={isPendingInterviewQuestions}
      />
    </div>
  );
}
